import React, { useState } from "react";
import DropDownQuestion from "./DropDownQuestion";

function ChildrenQuestion(props) {
  const [numVal, setNumVal] = useState(props.Answer);
  function handleItems() {
    var itemVal = numVal;
    if (itemVal) {
      if (itemVal > 0) {
        var elements = [];
        for (var i = itemVal; i > 0; i--) {
          elements.push(
            React.cloneElement(props.children, {
              key: i,
              id: i,
              handleValue: props.handleValue,
            })
          );
        }
        return elements;
      }
    }
  }
  function handleValue(event) {
    const value = event.target.value;
    setNumVal(value);
    props.handleValue(event);
  }
  return (
    <DropDownQuestion
      id={props.id}
      QuestionText={props.QuestionText}
      GuidelineText={props.GuidelineText}
      Choices={Array.from(Array(11).keys())}
      handleValue={handleValue}
      Answer={props.Answer}
    >
      {handleItems()}
    </DropDownQuestion>
  );
}

export default ChildrenQuestion;
